import { render, staticRenderFns } from "./TransactionListItem.vue?vue&type=template&id=3b4fc10e&scoped=true&"
import script from "./TransactionListItem.vue?vue&type=script&lang=js&"
export * from "./TransactionListItem.vue?vue&type=script&lang=js&"
import style0 from "./TransactionListItem.vue?vue&type=style&index=0&id=3b4fc10e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4fc10e",
  null
  
)

export default component.exports